<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="680"
        persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-if="buttonText != null">
          <v-btn
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              :loading="loading"
          >
            {{ buttonText }}
          </v-btn>
        </span>
        <span v-else>
          <v-icon
              v-bind="$attrs"
              v-on="on"
              dark
              :loading="loading"
          >
            {{ icon }}
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
        </v-card-title>

        <v-card-text>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field v-model="value.title" label="Title"
                          required
                          :rules="titleRules"
                          :counter="100"
                          outlined clearable clear-icon="mdi-close-circle"></v-text-field>
            <v-textarea v-model="value.description" label="Description" auto-grow
                        outlined clearable clear-icon="mdi-close-circle"></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onClose">Cancel</v-btn>
          <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

export default {
  name: 'StoreDocDialog',
  props: {
    icon: {type: String},
    buttonText: {type: String},
    title: {type: String},
    value: {type: Object},
    isNewItem: {type: Boolean, default: false},
  },

  computed: {},

  methods: {
    async fetchSaveDocItem(item) {
      let self = this
      this.loading = true
      let csrfToken = this.$cookies.get('csrftoken')
      let data = new FormData()
      data.append('title', item.title)
      data.append('description', item.description)
      const requestParams = {
        method: "PATCH",
        headers: {
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: data,
      };
      let response = await fetch("/api/store_doc/" + item.id + "/", requestParams)
      if (!response.ok) {
        console.log(response)
        const result = await res.json()
        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        self.loading = false
        return
      }
      let json = await response.json()
      this.loading = false
      this.$emit('change', json)
    },
    async fetchNewDocItem(item) {
      this.loading = true
      let csrfToken = this.$cookies.get('csrftoken')
      let data = new FormData()
      data.append('title', item.title)
      data.append('description', item.description)
      const requestParams = {
        method: "POST",
        headers: {
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: data,
      };
      let response = await fetch("/api/store_doc/", requestParams)
      if (!response.ok) {
        console.log(response)
        const result = await res.json()
        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        self.loading = false
        return
      }
      let json = await response.json()
      this.loading = false
      this.$emit('input', json)
      this.$emit('change', json)
    },
    onClose() {
      this.dialog = false
    }
    ,
    onSave() {
      this.dialog = false
      if (this.isNewItem)
        this.fetchNewDocItem(this.value)
      else
        this.fetchSaveDocItem(this.value)
    }
    ,
  },

  mounted() {
  }
  ,

  data() {
    return {
      dialog: false,
      loading: false,
      valid: false,
      titleRules: [v => !!v || 'Title is required', v => (v && v.length <= 100) || 'Title must be less than 100 characters',],
    }
  }
  ,
}

</script>


<style scoped lang="scss">
</style>